import { render, staticRenderFns } from "./tipoContatoChartSideBar.vue?vue&type=template&id=04548aca"
import script from "./tipoContatoChartSideBar.vue?vue&type=script&lang=js"
export * from "./tipoContatoChartSideBar.vue?vue&type=script&lang=js"
import style0 from "./tipoContatoChartSideBar.vue?vue&type=style&index=0&id=04548aca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports